import styled from 'styled-components';

export const Wrapper = styled.main`
  display: flex;
  width: 100%;
  position: fixed;
`;
